import { create } from "zustand";

const useHomeStore = create((set) => ({
  // ----- STATE -----
  HomePageLinks: {
    clientLink: "",
    aboutLink: "",
    servicesLink: "",
    newsLink: "",
    contactLink: "",
    termsLink: "",
    privacyLink: "",
    accesibilityStatementLink: "",
  },

  // ----- ACTIONS -----
  setLinks: (responseLinks) =>
    set({
      HomePageLinks: {
        clientLink: responseLinks.homeClient || "",
        aboutLink: responseLinks.homeAbout || "",
        servicesLink: responseLinks.homeServices || "",
        newsLink: responseLinks.homeNews || "",
        contactLink: responseLinks.homeContact || "",
        termsLink: responseLinks.homeTermsOfService || "",
        privacyLink: responseLinks.homePrivacyPolicy || "",
        accesibilityStatementLink:
          responseLinks.homeAccessibilityStatement || "",
      },
    }),

}));

export default useHomeStore;